import { useContext } from 'react'
import { ILoadingObj, StoreContextType } from '@/context/types'

const Loading = (context: React.Context<StoreContextType | null>) => {
  const store = useContext(context) as StoreContextType

  const getLoading = () => store.loadings.loading

  const setLoading = (loadingObj: ILoadingObj) => {
    store.loadings.setLoading(loadingObj)
  }

  return { getLoading, setLoading }
}

export default Loading
